import { SupplyNoPerspectiveContainer } from "./container";

export const SupplyNoPerspectivePage = () => {
  return <SupplyNoPerspectiveContainer />;
};
